import React, { ReactElement } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import {
    RouteContainer,
    RouteContent,
    animationClassNames,
    ANIMATION_DURATION_IN_MS,
} from './styles';

type FadeInOutRouteWrapProps = {
    className?: string;
    children: ReactElement;
    animateRoutes?: string[];
    location: {
        key: string;
        pathname: string;
    };
};

const FadeInOutRouteWrap = ({
    className,
    children,
    location,
    animateRoutes = [],
    ...restProps
}: FadeInOutRouteWrapProps): JSX.Element => {
    const routeName =
        animateRoutes.find((route) => location.pathname.includes(route)) ?? location.pathname;

    return (
        <RouteContainer className={className} {...restProps}>
            <SwitchTransition>
                <CSSTransition
                    key={routeName}
                    classNames={animationClassNames}
                    timeout={ANIMATION_DURATION_IN_MS}
                >
                    <RouteContent>{children}</RouteContent>
                </CSSTransition>
            </SwitchTransition>
        </RouteContainer>
    );
};

export default FadeInOutRouteWrap;
